import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseA1A2 = props => <ServerComponentCaller url={"assets/data/pages/licencias/A1A2antiguas.json"}/>;

LicenciaClaseA1A2.propTypes = {};

export default LicenciaClaseA1A2;
